import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./reducers/authReducer";
import myCartSlice from "./reducers/cartReducer";
import layoutSlice from "./reducers/layoutReducer";

const store = configureStore({
  reducer: {
    layout: layoutSlice,
    auth: authSlice,
    myCart: myCartSlice,
  },
});

export default store;
